import { render, staticRenderFns } from "./wsWebinarRoomHeader.vue?vue&type=template&id=b452ac2c&scoped=true&"
import script from "./wsWebinarRoomHeader.vue?vue&type=script&lang=js&"
export * from "./wsWebinarRoomHeader.vue?vue&type=script&lang=js&"
import style0 from "./wsWebinarRoomHeader.vue?vue&type=style&index=0&id=b452ac2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452ac2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
